import React from 'react';
import { List, Spin, Row, Col, Avatar, BackTop, Icon, Popconfirm, Popover, Upload, message, Tooltip,Button } from 'antd';
// import { NHFetch, NHModal, getSize, createUuid, NHRadioGroup, NHConfirm, Button, hasAuth } from 'xgui-for-react';
import NHFetch from '../../utils/NHFetch';
import getSize from '../../utils/getSize';
import createUuid from '../../utils/createUuid';
import {hasAuth} from "../../utils/NHCore";
import {NHModal, NHConfirm} from '../common/NHModal';
import NHRadioGroup from '../common/NHRadioGroup';


import InfiniteScroll from 'react-infinite-scroller';

import PageSize from './PageSize';
import SearchComponent from './search';
import UploadModal from './UploadForm';
import DownloadForm from './DownloadForm';


import config from './config';

import styles from './index.css';

/**
 * 学生照片管理
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2019-05-22 
 * Version: 1.0
 * Modify log:
 */
class StudentPhotoMng extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            searchParams: {
                filter: {},
                photoType: '10',
                pageNum: 0,
                pageSize: 20,
                pages: 0,
                total: 0
            },
            loading: false,
            hasMore: true,
            expand: false,
        }
    }

    componentDidMount() {

        this.reSetPageSize(() => {
            this.fetchData();
        });
        window.addEventListener('resize', this.onWindowResize);
    }

    //监听处理窗口缩放变化
    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }

    onWindowResize = () => {
        this.reSetPageSize();
    }

    reSetPageSize = (callback) => {

        let contentW = getSize().windowW - 279;
        let contentH = getSize().windowH - 65;

        let colNum = parseInt(contentW * 0.0065, 0) > 1 ? parseInt(contentW * 0.0065, 0) : 1;//当前窗口大小能显示的照片列数
        let rowNum = parseInt(contentH * 0.007, 0) > 1 ? parseInt(contentH * 0.007, 0) : 1;//当前窗口大小能显示的照片行数

        let pageSize = colNum * rowNum;//当前窗口大小能显示的照片数量

        let { searchParams } = this.state;
        searchParams = { ...searchParams, pageSize: pageSize };

        this.setState({ searchParams }, () => {
            if (callback instanceof Function) {
                callback();
            }
        });
    }

    /**
     * * 加载数据
     * @memberof StudentPhotoMng
     */
    fetchData = () => {


        let { data, searchParams, hasMore } = this.state;
        let { pageNum } = searchParams;

        if (hasMore) {

            this.setState({ loading: true });

            let params = { ...searchParams };

            params['pageNum'] = parseInt(pageNum + 1, 0);

            NHFetch('api/sm-student/studentPhotoMng/getStudentPhotoInfo', "POST", params).then(res => {
                if (res) {
                    if (res.data) {
                        let newParams = res.data.searchParams;
                        let { pageNum, pages } = newParams;
                        if (pageNum === pages) {
                            message.success('照片已加载完毕');
                            data = data.concat(res.data.list);
                            this.setState({
                                data,
                                searchParams: { ...searchParams, ...newParams },
                                loading: false,
                                hasMore: false,
                            });
                        } else {
                            data = data.concat(res.data.list);
                            this.setState({
                                data,
                                searchParams: { ...searchParams, ...newParams },
                                loading: false,
                            });
                        }
                    }
                }
            });
        }

    };

    /**
     * * 滚动加载
     * @memberof StudentPhotoMng
     */
    handleInfiniteOnLoad = () => {
        this.fetchData();
    };

    /**
     * * 查询
     * @memberof StudentPhotoMng
     */
    onSearch = () => {

        this.searchForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if(formData && formData.searchValue){
                formData.searchValue = formData.searchValue.trim();
            }
            let { searchParams } = this.state;
            searchParams = { ...searchParams, filter: formData };

            searchParams = { ...searchParams, pageNum: 0 };
            this.setState({ data: [], searchParams, hasMore: true }, () => {
                this.fetchData();
            });
        });
    }

    /**
     * * 重置
     * @memberof StudentPhotoMng
     */
    onReload = () => {
        let { searchParams } = this.state;
        searchParams = { ...searchParams, filter: {}, pageNum: 0 };
        this.setState({ data: [], searchParams, hasMore: true }, () => {
            this.fetchData();
        });
    }

    /**
     * * 照片类型值变化回调
     * @memberof StudentPhotoMng
     */
    onPhotoTypeChange = (type) => {
        let { searchParams } = this.state;
        searchParams = { ...searchParams, photoType: type, pageNum: 0 };
        this.setState({ data: [], searchParams, hasMore: true }, () => {
            this.fetchData();
        });
    }

    /**
     * * 上传前校验照片格式、大小
     * @memberof StudentPhotoMng
     */
    beforeUpload = (file) => {
        const allowType = "jpeg,jpg,png,bmp,JPEG,JPG,PNG,BMP";
        let fix = file.name.split(".");
        const isImage = allowType.indexOf(fix[fix.length - 1]) >= 0;
        if (!isImage) {
            message.error('只能上传 jpeg、jpg、png、bmp 格式的照片');
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('照片大小不能大于10M');
        }
        return isImage && isLt10M;
    }

    /**
     * * 单个学生照片上传
     * @memberof StudentPhotoMng
     */
    onUploadSinglePhoto = (info) => {
        if (info.file.status === 'done' && info.file.response.data) {
            message.success(`${info.file.name} 上传成功`);
            const data = this.state.data;
            this.setState({ data });
        } else if (info.file.status === 'error' || (info.file.status === 'done' && !info.file.response.data)) {
            message.error(`${info.file.name} 上传失败`);
        }
    }

    /**
     * * 单个学生照片删除
     * @memberof StudentPhotoMng
     */
    onDelete = (xsid, zplxm) => {
        NHFetch('/studentPhotoMng/deleteByXsidAndZplxm', "POST", { xsid, zplxm }).then(res => {
            if (res) {
                if (res.data) {
                    message.success(`删除成功`);
                    const data = this.state.data;
                    this.setState({ data });
                } else {
                    message.error('暂未找到该学生照片，删除失败');
                }
            }
        });
    }

    /**
     * * 批量上传
     * @memberof StudentPhotoMng
     */
    batchUpload = () => {
        this.refs.uploadModal.show();
    }

    /**
     * * 批量上传照片保存
     * @memberof StudentPhotoMng
     */
    handleUploadSave = (stopLoading) => {
        this.uploadForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }

            let param = { zhlx: formData.zhlx, zplx: formData.zplx, fileList: [] };

            for (let i = 0; i < formData.file.fileList.length; i++) {
                let name = formData.file.fileList[i].name;
                let fileName = formData.file.fileList[i].response.data;
                let code = formData.file.fileList[i].response.code;
                param.fileList.push({ name, fileName, code });
            }

            NHFetch("/studentPhotoMng/batchUpload", "POST", param)
                .then(res => {
                    if(res && res.data){
                        stopLoading();
                        let result = res.data;
                        if (result.status === 'success') {
                            message.success(result.msg);
                            this.refs.uploadModal.close();
                            this.onSearch();
                        } else {
                            message.warning(result.msg);
                        }
                    }else{
                        message.error("文件夹格式有误，请重新上传")
                    }
                });

        });
    }

    /**
     * * 批量下载
     * @memberof StudentPhotoMng
     */
    batchDownload = () => {
        this.refs.downloadModal.show();
    }

    /**
     * * 批量下载保存
     * @memberof StudentPhotoMng
     */
    handleDownloadSave = (stopLoading) => {
        this.downloadForm.validateFields((err, formData) => {

            if (err) {
                stopLoading();
                return;
            }

            let nameFields = "";
            formData["nameFields"].map(item => {
                nameFields += item + "-";
            });

            if (nameFields.indexOf("xh") === -1 && nameFields.indexOf("ksh") === -1 && nameFields.indexOf("sfzjh") === -1) {
                NHConfirm("请至少在学号，考生号，身份证件号中选择一项命名条件！");
                stopLoading();
                return;
            }

            let param = {
                nameFields: formData["nameFields"],
                classifyFields: formData["classifyFields"],
                searchParams: this.state.searchParams
            }

            fetch(config.baseUrl + '/studentPhotoMng/batchDownload', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(param)
            }).then(response => response.blob())
                .then(data => {
                    stopLoading();
                    let timestamp = new Date().getTime();
                    const fileName = '学生照片' + timestamp + '.zip';
                    if ('download' in document.createElement('a')) { // 非IE下载    
                        const elink = document.createElement('a');
                        elink.download = fileName;
                        elink.style.display = 'none';
                        elink.href = URL.createObjectURL(data);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href) // 释放URL 对象    
                        document.body.removeChild(elink)
                    } else { // IE10+下载    
                        navigator.msSaveBlob(data, fileName)
                    }
                })
        });
    }

    render() {

        const { data, loading, hasMore, searchParams } = this.state;
        const { photoType, pageNum, pageSize, pages, total } = searchParams;

        return (
            <Spin spinning={loading} size="large">
                <div id="student-photo-content-div" className={styles.main_content} style={{ height: getSize().windowH - 88 }}>
                    {/* 回到顶部 */}
                    <BackTop target={() => document.getElementById('student-photo-content-div')} >
                        <div className={styles.ant_back_top_inner}>
                            <Icon type="to-top" />
                        </div>
                    </BackTop>

                    {/* 右下角照片数量提示 */}
                    <PageSize pageNum={data.length} total={total} />

                    {/* 搜索栏 */}
                    <SearchComponent ref={(searchForm) => this.searchForm = searchForm} onSearch={this.onSearch} onReload={this.onReload} />

                    {/* 操作栏 */}
                    <Row type="flex" justify="space-between">
                        <Col>
                            <Button type={'primary'} onClick={this.batchUpload} auth={'ly-sm-student-svc_studentPhotoMng_batchUpload'}>批量上传</Button>
                            <Button type={'primary'} style={{ marginLeft: 10 }} ghost onClick={this.batchDownload} auth={'ly-sm-student-svc_studentPhotoMng_batchDownload'}>批量下载</Button>
                        </Col>
                        <Col style={{ textAlign: "right" }}>
                            <NHRadioGroup sign={'DMK_XSXX_ZPLXM'} radioButton={true} value={photoType} onChange={this.onPhotoTypeChange} />
                        </Col>
                    </Row>

                    {/* 照片列表 */}
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.handleInfiniteOnLoad}
                        hasMore={!loading && hasMore}
                        useWindow={false}
                    >
                        <List
                            style={{ marginTop: 16 }}
                            grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 6, xl: 8, xxl: 10 }}
                            dataSource={data}
                            renderItem={item => {
                                let actions = [];

                                if (hasAuth('ly-sm-student-svc_studentPhotoMng_upload')) {
                                    actions.push(
                                        <Upload
                                            name='singlePhoto'
                                            action={`api/sm-student/studentPhotoMng/uploadSingleStudentPhoto?xsid=${item.XSID}&zplxm=${photoType}`}
                                            accept={'image/*'}
                                            beforeUpload={this.beforeUpload}
                                            onChange={this.onUploadSinglePhoto}
                                        >
                                            <Icon type="cloud-upload" />
                                        </Upload>
                                    );
                                }

                                if (hasAuth('ly-sm-student-svc_studentPhotoMng_download')) {
                                    actions.push(
                                        <a className={styles.download} href={`api/sm-student/studentPhotoMng/downloadSingleStudentPhoto?xsid=${item.XSID}&zplxm=${photoType}`}>
                                            <Icon type="download" />
                                        </a>
                                    );
                                }

                                if (hasAuth('ly-sm-student-svc_studentPhotoMng_delete')) {
                                    actions.push(
                                        <Popconfirm
                                            title="确定删除该学生照片?"
                                            onConfirm={() => this.onDelete(item.XSID, photoType)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <Icon type="delete" />
                                        </Popconfirm>
                                    );
                                }

                                return (
                                    <List.Item
                                        extra={
                                            <div>
                                                <div className={`${styles.list_item_extra} ${item.XBM === '1' ? styles.list_item_extra_boy : styles.list_item_extra_gril}`}>
                                                    {item.XM.length > 7 ?
                                                        <Tooltip title={item.XM}>{item.XM}</Tooltip>
                                                        :
                                                        item.XM
                                                    }
                                                </div>
                                                <div className={styles.list_item_extra}>
                                                    {item.XH&&item.XH.length > 12 ?
                                                        <Tooltip title={item.XH}>{item.XH}</Tooltip>
                                                        :
                                                        item.XH
                                                    }
                                                </div>
                                            </div>
                                        }
                                        actions={actions.length > 0 ? actions : null}
                                    >
                                        <Popover
                                            trigger="click"
                                            placement="right"
                                            content={
                                                <div>
                                                    <p><b>入学年份：</b>{item.RXNF}</p>
                                                    <p><b>学生类别：</b>{item.XSLB}</p>
                                                    <p><b>校区：</b>{item.XQMC}</p>
                                                    <p><b>学院：</b>{item.BMMC}</p>
                                                    <p><b>专业：</b>{item.ZYMC}</p>
                                                    <p><b>班级：</b>{item.BJMC}</p>
                                                </div>
                                            }
                                        >
                                            <Avatar className={styles.list_item_avatar} shape="square"
                                                src={`api/sm-student/studentPhotoMng/queryImgByXsidAndZplxm?&zplxm=${photoType}&xsid=${item.XSID}&${createUuid()}`} />
                                        </Popover>
                                    </List.Item>
                                )
                            }}
                        >
                        </List>
                    </InfiniteScroll>
                    <NHModal
                        ref="uploadModal"
                        width={720}
                        title="学生照片批量上传"
                        onOk={this.handleUploadSave}
                    >
                        <UploadModal ref={form => this.uploadForm = form} />
                    </NHModal>
                    <NHModal
                        ref="downloadModal"
                        width={720}
                        title="学生照片批量下载"
                        onOk={this.handleDownloadSave}
                    >
                        <DownloadForm ref={form => this.downloadForm = form} total={total} />
                    </NHModal>
                </div>
            </Spin >
        )
    }

}

export default StudentPhotoMng;


// WEBPACK FOOTER //
// ./components/studentPhotoMng/index.js